import { render, staticRenderFns } from "./FileDiffChange.vue?vue&type=template&id=75653a05&scoped=true&"
import script from "./FileDiffChange.vue?vue&type=script&lang=js&"
export * from "./FileDiffChange.vue?vue&type=script&lang=js&"
import style0 from "./FileDiffChange.vue?vue&type=style&index=0&id=75653a05&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75653a05",
  null
  
)

export default component.exports